import {
  ApplicationConfig,
  EnvironmentProviders,
  Provider,
  provideBrowserGlobalErrorListeners,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter, withHashLocation } from '@angular/router';
import { appRoutes } from './app.routes';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import mytheme from '../../mytheme';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { httpConfigInterceptor } from './shared/interceptors/http-config/http-config.interceptor';
import { RECAPTCHA_SETTINGS, RecaptchaSettings } from 'ng-recaptcha';
import { environment } from './environments/environment';

/**
 * Shared between browser (`appConfig`) and server (`app.config.server.ts`).
 * Router is added separately: browser uses `withHashLocation()`, server uses path URLs only.
 */
export const sharedAppProviders: Array<Provider | EnvironmentProviders> = [
  provideBrowserGlobalErrorListeners(),
  provideZoneChangeDetection({ eventCoalescing: true }),
  provideHttpClient(withFetch(), withInterceptors([httpConfigInterceptor])),
  provideAnimationsAsync(),
  providePrimeNG({
    theme: {
      preset: mytheme,
      options: {
        darkModeSelector: false
      }
    },
  }),
  {
    provide: RECAPTCHA_SETTINGS,
    useValue: {
      siteKey: environment.RECAPTCHA_SITE_KEY,
    } as RecaptchaSettings,
  },
];


export const appConfig: ApplicationConfig = {
  providers: [...sharedAppProviders, provideRouter(appRoutes, withHashLocation(),)],
};
